import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  FormControl,
  Tooltip,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "tss-react/mui";
import { FieldProps, getIn } from "formik";
import { FieldOption } from "./FieldOption";
import { questionImageAlt } from "./questionImageAlt";

const useStyles = makeStyles()(() => ({
  image: {
    maxWidth: "100%",
  },
}));

interface FormikRadioGroupProps extends FieldProps {
  name?: string;
  options: FieldOption[];
  label: string;
  tooltip?: string;
  imageUrl?: string;
}

const FormikRadioGroup = ({
  field,
  form: { touched, errors },
  name,
  options,
  label,
  tooltip,
  imageUrl,
  ...props
}: FormikRadioGroupProps) => {
  const fieldName = name || field.name;

  const { classes } = useStyles();

  return (
    <FormControl component="fieldset" fullWidth>
      <Typography
        variant="body1"
        gutterBottom
        color={
          getIn(touched, fieldName) && getIn(errors, fieldName)
            ? "error"
            : undefined
        }
      >
        {label}
        {tooltip && (
          <Tooltip title={tooltip}>
            <span>
              <IconButton disabled={true}>
                <HelpIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </Typography>
      {imageUrl && (
        <img src={imageUrl} className={classes.image} alt={questionImageAlt(imageUrl)} />
      )}
      <RadioGroup aria-label={fieldName} {...field} {...props} name={fieldName}>
        {options.map((option) => (
          <FormControlLabel
            data-option-id={`${fieldName}#${option.value}`}
            key={option.id}
            value={option.value}
            control={<Radio />}
            label={option.text}
          />
        ))}
      </RadioGroup>

      {getIn(touched, fieldName) && getIn(errors, fieldName) && (
        <Typography variant="body1" gutterBottom color="error">
          {String(getIn(errors, fieldName))}
        </Typography>
      )}
    </FormControl>
  );
};

export default FormikRadioGroup;
